import axios from "axios";
import { selectCells } from "jodit/esm/plugins/select-cells/select-cells";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ReleaseModal from "./releasemodal.tsx";
import ReceiptModal from "./receiptmodal.tsx";
type CustomerDetailModuleProps = {
  tab: string,
  setTab: (tab: string) => void,
  customer: any,
  setSelectedId: (id: any) => void,
  baseUrl: string,
  currentUser: any,
  client: any,
}
export default function CustomerDetailModule({ tab, setTab, customer, setSelectedId, baseUrl, currentUser, client }: CustomerDetailModuleProps) {
  // const customer = {
  //   id: "CUST-001",
  //   name: "Ola Normann ",
  //   email: "ola@chamcore.com",
  //   phone: "+47 96702167",
  //   status: "active" as "active" | "inactive",
  //   totalSpentNok: 9245,
  //   totalMinutes: 121,
  //   lastActive: "I dag 13:02",
  //   country: "Norge",
  //   city: "Oslo",
  //   zip: "0563",
  //   address: "Hovedgata 21A",
  //   paymentMethods: ["Vipps", "Stripe", "Wallet"],
  // };



  const [otpSent, setOtpSent] = useState(false);
  const [selectedCall, setSelectedCall] = useState(null);
  const [methodFilter, setMethodFilter] = useState("all");
  const [advisorFilter, setAdvisorFilter] = useState("all");
  const [sortBy, setSortBy] = useState("all");
  const [paging, setPaging] = useState(0);
  const CALLS_PER_PAGE = 10;
  const PAGE_BUTTONS_TO_SHOW = 5;
  const [totalCalls, setTotalCalls] = useState(0);

  const [calls, setCalls] = useState([{}]);

  const [loadingCalls, setLoadingCalls] = useState(false);

  const [openReleaseModal, setOpenReleaseModal] = useState(false);

  const [openReceiptModal, setOpenReceiptModal] = useState(false);

  const getCalls = async (customer_uid: string, page: number) => {
    try {
      setLoadingCalls(true);
      const response = await axios.get(baseUrl + '/getCallsByCustomerUid', {
        params: {
          token: currentUser?.token,
          customer_uid: customer_uid,
          paging: page === 0 ? page : page * CALLS_PER_PAGE,
          length: CALLS_PER_PAGE,
          method: methodFilter,
          agent_id: advisorFilter,
          sortBy: sortBy,
        }
      })
      if (response.data.status === "OK") {
        setCalls(response.data.data);
        setTotalCalls(response.data.totalCalls);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingCalls(false);
    }
  }
  const totalPages = Math.ceil(totalCalls / CALLS_PER_PAGE);

  const goToPage = (page: number) => {
    if (page < 0 || page >= totalPages) return;
    setPaging(page);
  };

  // Calculate visible page buttons dynamically
  const getVisiblePages = () => {
    let start = Math.max(paging - Math.floor(PAGE_BUTTONS_TO_SHOW / 2), 0);
    let end = start + PAGE_BUTTONS_TO_SHOW;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(end - PAGE_BUTTONS_TO_SHOW, 0);
    }

    const pages = [];
    for (let i = start; i < end; i++) {
      pages.push(i);
    }
    return pages;
  };
  useEffect(() => {
    getCalls(customer?.uid, paging);
  }, [customer, paging, methodFilter, advisorFilter, sortBy])

  const [agents, setAgents] = useState([{}]);

  const getAgents = async () => {
    try {
      const response = await axios.get(baseUrl + '/getAllAgents', { params: { token: currentUser?.token, client_uid: client?.uid } });

      if (response.data.status === "OK") {
        setAgents(response.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    getAgents();
  }, [client, baseUrl])

  const exportCsv = () => {
    alert("Eksport til CSV – kobles mot backend senere.");
  };

  const exportPdf = () => {
    alert("Eksport til PDF – kobles mot backend senere.");
  };



  const handleReleaseClick = async () => {
    setOpenReleaseModal(true);
  }

  const handleCaptureClick = async () => {
    try {
      let formData = new FormData();
      formData.append("token", currentUser.token);
      formData.append("amount", selectedCall?.charge_price);
      formData.append("reason", "");
      formData.append("note", "");
      formData.append("max_amount", selectedCall?.charge_price);
      formData.append("type", "capture");
      formData.append("call_id", selectedCall?.cid);
      formData.append("client_uid", client?.uid);
      const response = await axios.post(baseUrl + '/supportCreateRefund', formData);
      if (response.data.status === "OK") {
        getCalls(customer?.uid, paging);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const handleMarkForInternalReviewClick = async () => {
    try {
      if (selectedCall) selectedCall.reason = 'Mark for internal review';
      let formData = new FormData();
      formData.append("token", currentUser?.token);
      formData.append("reason", "Mark for internal review");
      formData.append("call_id", selectedCall.id);
      const response = await axios.post(baseUrl + '/updateCallStatus', formData);

      if (response.data.status === "OK") {
        Swal.fire({
          title: 'Suksess',
          icon: 'success',
          text: response.data.data,
          timer: 1500,
        })
      } else {
        Swal.fire({
          title: 'Error',
          icon: 'error',
          text: response.data.data,
        })
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    function handleEsc(event: any) {
      if (event.key === "Escape") setSelectedCall(null);
    }
    document.addEventListener("keydown", handleEsc);
  }, [])

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-6 sm:px-8 sm:py-10">
      {/* TOP BAR */}
      <button
        className="mb-6 text-slate-500 hover:text-slate-900 text-sm"
        onClick={() => setSelectedId(null)}
      >
        ← Tilbake til kundeliste
      </button>

      {/* HEADER */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-3">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-1">
            {customer?.name}
          </h1>
          <p className="text-sm text-slate-500">Kundedetaljer og administrasjon</p>
        </div>
        <span
          className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium border ${customer?.is_active === "1"
            ? "bg-emerald-50 text-emerald-700 border-emerald-200"
            : "bg-slate-50 text-slate-500 border-slate-200"
            }`}
        >
          <span className="mr-1 h-1.5 w-1.5 rounded-full bg-current" />
          {customer?.is_active === "1" ? "Aktiv" : "Inaktiv"}
        </span>
      </div>

      {/* KPI ROW */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <p className="text-[11px] uppercase text-slate-500">Akkumulert omsetning</p>
          <p className="text-2xl font-semibold text-slate-900 mt-1">
            {customer?.totalSpent} NOK
          </p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <p className="text-[11px] uppercase text-slate-500">Total samtaletid</p>
          <p className="text-2xl font-semibold text-slate-900 mt-1">
            {customer?.totalMinutes} min
          </p>
        </div>
      </div>

      {/* INFO + ACTIONS GRID */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        {/* LEFT COLUMN */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 flex flex-col gap-4">
          <h2 className="text-lg font-semibold text-slate-900 mb-2">Kundeinformasjon</h2>
          <div className="text-sm text-slate-600 space-y-1">
            <p>
              <span className="font-medium text-slate-900">Kunde-ID:</span> {customer?.id}
            </p>
            <p>
              <span className="font-medium text-slate-900">E-post:</span> {customer?.email}
            </p>
            <p>
              <span className="font-medium text-slate-900">Telefon:</span> {customer?.phone}
            </p>
            <p>
              <span className="font-medium text-slate-900">Adresse:</span> {customer?.address1}
            </p>
            <p>
              <span className="font-medium text-slate-900">Postkode:</span> {customer?.postal_code}
            </p>
            <p>
              <span className="font-medium text-slate-900">By:</span> {customer?.city}
            </p>
            <p>
              <span className="font-medium text-slate-900">Land:</span> {customer?.country}
            </p>
          </div>
        </div>

        {/* PAYMENT + SUPPORT */}
        {(customer?.sub || customer?.card_token) && (
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 flex flex-col gap-6">
            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">Betalingsmetoder</h2>
              <div className="flex flex-wrap gap-3">
                {customer?.sub && (
                  <span
                    className="px-3 py-1.5 rounded-full text-xs font-medium bg-orange-500 border border-orange-800 text-white"
                  >
                    {"Vipps"}
                  </span>
                )}
                {customer?.card_token && (
                  <span
                    className="px-3 py-1.5 rounded-full text-xs font-medium bg-purple-700 border border-purple-800 text-white"
                  >
                    {"Stripe"}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ACTIVITY LOG */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <h2 className="text-lg font-semibold text-slate-900 mb-3">Siste aktivitet</h2>
          <ul className="space-y-3 text-sm text-slate-700">
            <li>📞 Samtale – {customer?.lastCall?.duration} min ({customer?.lastCall?.created_at})</li>
          </ul>
        </div>
      </div>

      {/* ECON SUMMARY + EXPORT */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 mb-6 flex flex-col lg:flex-row gap-6 lg:items-center lg:justify-between">
        <div>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">
            Økonomisk oversikt (filtrert periode)
          </h2>
          <p className="text-sm text-slate-500 mb-3">
            Basert på samtalehistorikken under.
          </p>
          <div className="flex flex-wrap gap-4 text-sm">
            <div>
              <p className="text-slate-500">Antall samtaler</p>
              <p className="font-semibold text-slate-900">{customer?.callsActivity.total_calls}</p>
            </div>
            <div>
              <p className="text-slate-500">Total varighet</p>
              <p className="font-semibold text-slate-900">{customer?.callsActivity.total_duration} min</p>
            </div>
            <div>
              <p className="text-slate-500">Total omsetning</p>
              <p className="font-semibold text-slate-900">
                {customer?.callsActivity.total_price?.toLocaleString("nb-NO")} NOK
              </p>
            </div>
            <div>
              <p className="text-slate-500">Fordeling per betalingsmetode</p>
              <p className="font-semibold text-slate-900">
                Vipps: {customer?.callsActivity.vipps_amount?.toLocaleString("nb-NO")} NOK · Stripe: {customer?.callsActivity.stripe_amount?.toLocaleString("nb-NO")} NOK
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={exportCsv}
            className="px-4 py-2 rounded-lg border border-slate-300 bg-slate-50 text-sm font-medium text-slate-800 hover:bg-slate-100"
          >
            Eksporter CSV
          </button>
          <button
            onClick={exportPdf}
            className="px-4 py-2 rounded-lg bg-slate-900 text-sm font-medium text-white hover:bg-slate-800"
          >
            Eksporter PDF
          </button>
        </div>
      </div>

      {/* CALL HISTORY WITH FILTERS */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-4">
          <div>
            <h2 className="text-lg font-semibold text-slate-900 mb-1">
              Samtalehistorikk
            </h2>
            <p className="text-sm text-slate-500">
              Detaljert logg per samtale med rådgiver, pris og betalingsmåte.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 text-sm">
            <div>
              <label className="block text-xs text-slate-500 mb-1">Betalingsmåte</label>
              <select
                value={methodFilter}
                onChange={(e) => setMethodFilter(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm"
              >
                <option value="all">Alle</option>
                <option value="Vipps">Vipps</option>
                <option value="Stripe">Stripe</option>
              </select>
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Veileder</label>
              <select
                value={advisorFilter}
                onChange={(e) => setAdvisorFilter(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm"
              >
                <option value="all">Alle</option>
                {agents.map((agent: any) => (
                  <option value={agent.uid}>{agent.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Sorter</label>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm"
              >
                <option value="all">All</option>
                <option value="missed">Missed</option>
                <option value="completed">Completed</option>
              </select>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-slate-500 border-b border-slate-200">
                <th className="py-2 pr-4">Dato</th>
                <th className="py-2 pr-4">Tid</th>
                <th className="py-2 pr-4">Veileder</th>
                <th className="py-2 pr-4">Lengde</th>
                <th className="py-2 pr-4">Pris</th>
                <th className="py-2 pr-4">Betaling</th>
                <th className="py-2 pr-4">Status</th>
                <th className="py-2">Detaljer</th>
              </tr>
            </thead>
            <tbody className="text-slate-700">
              {loadingCalls && (
                <tr>
                  <td colSpan={7}>
                    <div className="flex items-center justify-center h-24">
                      <div className="flex flex-col items-center">
                        <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                        <p className="mt-3 text-gray-600 animate-pulse">Laster...</p>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {!loadingCalls && calls.map((call) => (
                <tr key={call.cid} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="py-2 pr-4">{call.date}</td>
                  <td className="py-2 pr-4">{call.time}</td>
                  <td className="py-2 pr-4">{call.agent_name}</td>
                  <td className="py-2 pr-4">{call.duration} min</td>
                  <td className="py-2 pr-4">{call.charge_price?.toLocaleString("nb-NO")} NOK</td>
                  <td className="py-2 pr-4">{call.payment_intent_id ? 'stripe' : 'vipps'}</td>
                  <td className="py-2 pr-4">{call.call_status}</td>
                  <td className="py-2">
                    <button
                      className="text-xs font-medium text-violet-700 hover:text-violet-900"
                      onClick={() => setSelectedCall(call)}
                    >
                      Vis
                    </button>
                  </td>
                </tr>
              ))}
              {!loadingCalls && calls.length === 0 && (
                <tr>
                  <td colSpan={7} className="py-6 text-center text-sm text-slate-400">
                    Ingen samtaler matcher filtrene.
                  </td>
                </tr>
              )}
              {/* PAGINATION */}
              {totalPages > 1 && (
                <tr>
                  <td colSpan={7}>
                    <div className="flex justify-center mt-4 gap-2 px-4 pt-4 pb-0">
                      <button
                        onClick={() => goToPage(paging - 1)}
                        disabled={paging === 0}
                        className="px-3 py-1 rounded border border-slate-300 bg-white disabled:opacity-50"
                      >
                        Prev
                      </button>

                      {getVisiblePages().map((i) => (
                        <button
                          key={i}
                          onClick={() => goToPage(i)}
                          className={`px-3 py-1 rounded border border-slate-300 ${paging === i ? "bg-indigo-500 text-white" : "bg-white"
                            }`}
                        >
                          {i + 1}
                        </button>
                      ))}

                      <button
                        onClick={() => goToPage(paging + 1)}
                        disabled={paging === totalPages - 1}
                        className="px-3 py-1 rounded border border-slate-300 bg-white disabled:opacity-50"
                      >
                        Next
                      </button>
                    </div>

                  </td>
                </tr>
              )}
              {totalCalls > 0 && (
                <tr>
                  <td colSpan={7} className="text-center">
                    <small className="text-gray-500"><em>Total no of records:</em> <b>{totalCalls}</b></small>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* CALL DETAIL MODAL */}
      {selectedCall && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 max-w-lg w-full mx-4 p-6">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-slate-900 mb-1">
                  Samtaledetaljer
                </h3>
                <p className="text-xs text-slate-500">
                  {selectedCall.date} kl. {selectedCall.time} · {selectedCall.duration} min med {selectedCall.agent_name}
                </p>
              </div>
              <button
                onClick={() => setSelectedCall(null)}
                className="text-slate-400 hover:text-slate-600 text-lg"
              >
                ×
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4 text-sm mb-4">
              <div>
                <p className="text-slate-500">Pris</p>
                <p className="font-semibold text-slate-900">
                  {selectedCall.charge_price?.toLocaleString("nb-NO")} NOK
                </p>
              </div>
              <div>
                <p className="text-slate-500">Betalingsmåte</p>
                <p className="font-semibold text-slate-900">{selectedCall.payment_intent_id ? 'stripe' : 'vipps'}</p>
              </div>
              <div>
                <p className="text-slate-500">Veileder</p>
                <p className="font-semibold text-slate-900">{selectedCall.agent_name}</p>
              </div>
              <div>
                <p className="text-slate-500">Betalingsreferanse</p>
                <p className="font-mono text-xs text-slate-900 break-all">
                  {selectedCall.reference ? selectedCall.reference : selectedCall.payment_intent_id}
                </p>
              </div>
              <div>
                <p className="text-slate-500">Call ID</p>
                <p className="font-mono text-xs text-slate-900 break-all">
                  {selectedCall.cid}
                </p>
              </div>
            </div>

            <div className="border-t border-slate-200 pt-4 flex flex-wrap gap-3">
              <button onClick={() => setOpenReceiptModal(true)} className="px-4 py-2 rounded-lg bg-slate-900 text-white text-xs font-medium hover:bg-slate-800">
                Send kvittering for denne samtalen
              </button>
              {selectedCall?.release && (
                <button onClick={handleReleaseClick} className="px-4 py-2 rounded-lg bg-rose-600 text-white text-xs font-medium hover:bg-rose-700">
                  Refusjon
                </button>
              )}
              {selectedCall?.capture && (
                <button onClick={handleCaptureClick} className="px-4 py-2 rounded-lg bg-green-600 text-white text-xs font-medium hover:bg-green-700">
                  Capture
                </button>
              )}
              {selectedCall?.reason !== "Mark for internal review" && (
                <button onClick={handleMarkForInternalReviewClick} className="px-4 py-2 rounded-lg border border-slate-300 bg-slate-50 text-xs font-medium text-slate-800 hover:bg-slate-100">
                  Marker for intern gjennomgang
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {selectedCall && (
        <>
          <ReleaseModal openReleaseModal={openReleaseModal} onClose={() => setOpenReleaseModal(false)} currentUser={currentUser} selectedCall={selectedCall} client={client} baseUrl={baseUrl} />
          <ReceiptModal open={openReceiptModal} setOpen={setOpenReceiptModal} baseUrl={baseUrl} currentUser={currentUser} client={client} selectedCall={selectedCall} customer={customer} />
        </>
      )}

    </div>
  );
}
